import styled from 'styled-components'

export const DefaultLayoutWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
export const MainContent = styled.main`
  width: calc(100% - 56px - 280px);
  padding: 24px;
  background-color: #f2f3f8;
  left: 336px;
  position: relative;
  min-height: 100vh;
`
